export default "__VITE_ASSET__BabT9urN__"